import './styles/noticeStyles.css';

import { Alert, AlertTitle, Box } from '@mui/material';
import React from 'react';

import { formatDate } from '../../../../common/utils/dates';
import { Notice } from '../../types';
import { useNotices } from './hooks/use-notices';

const NoticesAlert = React.memo(() => {
  const { notices } = useNotices();

  return (
    <Box
      id="notice-container"
      sx={{
        width: '100%',
        px: 2,
        pb: 1
      }}
    >
      {notices.map((notice: Notice, index: number) => (
        <Alert severity={notice.severity} key={index} sx={{ width: '100%' }}>
          <AlertTitle>{notice.title}</AlertTitle>
          {notice.message} <br />
          <strong>{formatDate(notice.endDate, 'Este mensaje expirará el DD de _month_ del YYYY')}</strong>
        </Alert>
      ))}
    </Box>
  );
});

NoticesAlert.displayName = 'NoticesAlert';

export default NoticesAlert;
